import NextImage from "@/app/components/lib/NextImage";
import PlayVideoIcon from "./PlayVideoIcon";

type TProps = {
  src: string;
  type: "image" | "video";
  className: string;
};

const VideoAttachmentMedia: React.FC<{ src: string }> = ({ src }) => (
  <div
    style={{
      width: "inherit",
      height: "inherit",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <PlayVideoIcon style={{ position: "absolute" }} />
    <video
      src={src}
      style={{
        borderRadius: "16px",
        objectFit: "cover",
        width: "inherit",
        height: "inherit",
      }}
    />
  </div>
);

const AttachmentMedia: React.FC<TProps> = ({ src, type, className }) => {
  return (
    <div className={className}>
      {type === "image" ? (
        <NextImage
          alt="gallery"
          src={src}
          sizes="500px"
          style={{
            objectFit: "cover",
            borderRadius: "16px",
          }}
        />
      ) : (
        <VideoAttachmentMedia src={src} />
      )}
    </div>
  );
};

export default AttachmentMedia;
